import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getcheck, getTypesList, getDevicesDetail } from '@blade-sxp/monitor/api/device-management/control';
let default_1 = class default_1 extends Vue {
    editForm;
    typesList = [];
    deviceId = '';
    form = {
        deviceType: '',
        rtspAddress: '',
        rtspReviewAddress: '',
        protocolType: '',
        username: '',
        dir: '',
        ip: '',
        port: '',
        password: '',
    };
    isDisabled = false;
    protocolTypeList = [
        {
            value: 'TCP',
        },
        {
            value: 'UDP',
        },
        {
            value: 'TCP_SERVER_MODE',
        },
    ];
    rules = {
        deviceType: [
            {
                required: true,
                message: this.$t('device.pleaseSelectDeviceType'),
                trigger: 'change',
            },
        ],
        rtspAddress: [
            {
                required: true,
                message: this.$t('device.pleaseEnterURL'),
                trigger: 'change',
            },
        ],
        username: [
            {
                required: true,
                message: this.$t('device.deviceUserName'),
                trigger: 'blur',
            },
        ],
        ip: [{ required: true,
                message: this.$t('device.IPAddress'),
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!/([0-9]\.?)+$/.test(this.form.ip)) {
                        return callback(new Error(this.$t('device.IPAddress').toString()));
                    }
                    callback();
                } }],
        port: [{ required: true,
                message: this.$t('device.port'),
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    console.log('port:', /[0-9]{1,6}$/.test(this.form.port));
                    if (!/[0-9]{1,6}$/.test(this.form.port) || Number(this.form.port) < 0 || Number(this.form.port) > 655535) {
                        return callback(new Error(this.$t('device.Port').toString()));
                    }
                    callback();
                } }],
        password: [{ required: true, message: this.$t('login.password'), trigger: 'blur' }],
        dir: [
            {
                required: true,
                message: this.$t('device.accessTheSourceRootDirectory'),
                trigger: 'blur',
            },
        ],
    };
    portChange() {
        this.form.port = new Number(this.form.port);
    }
    handleConnect() {
        this.$refs.formConnect.validate((valid) => {
            if (valid) {
                getcheck(this.form)
                    .then((res) => {
                    if (res.data.data.ready) {
                        this.isDisabled = true;
                        if (this.form.deviceType === 'VN_ONVIF') {
                            this.form.rtspAddress = res.data.data.rtsp;
                        }
                    }
                    else {
                        this.$message.error(this.$t('connectionFaild').toString());
                        return;
                    }
                    this.$emit('handle-connect');
                })
                    .catch((err) => {
                    this.$message({
                        message: err,
                        type: 'error',
                    });
                });
            }
        });
    }
    getTypesList() {
        getTypesList({}).then((resp) => {
            this.typesList = resp.data.data;
        });
    }
    changedeviceType() {
        this.form.rtspAddress = '';
        this.form.rtspReviewAddress = '';
        this.form.ip = '';
        this.form.port = '';
        this.form.username = '';
        this.form.password = '';
        this.form.dir = '';
        this.form.protocolType = '';
        this.$emit('change-type');
    }
    getDevicesDetail(deviceId) {
        // 设备详情
        getDevicesDetail(deviceId).then((resp) => {
            this.form = { ...resp.data.data };
            // this.form.rtspAddress = this.form.rtspReviewAddress;
            this.$emit('handle-connect');
        });
    }
    mounted() {
        if (this.$route.path === '/users/control/editDevice' && this.$route.query.id) {
            let id = this.$route.query.id.toString();
            this.getDevicesDetail(id);
            this.isDisabled = true;
        }
        this.getTypesList(); // 设备类型列表
    }
};
__decorate([
    Prop()
], default_1.prototype, "editForm", void 0);
default_1 = __decorate([
    Component({
        name: 'Form',
        i18n: {
            messages: {
                'en-us': {
                    connectionFaild: 'Connection failed, please check connection parameters',
                    selectDeviceType: 'Please select device type',
                    Tips: 'Tip: The username and password in the URL cannot contain symbols such as "@" or ":" or "/"',
                },
                zh: {
                    connectionFaild: '连接失败，请检查连接参数',
                    selectDeviceType: '请选择设备类型',
                    Tips: '提示：URL中的用户名和密码不能带有“@”或“:”或“/”等符号',
                },
            },
        },
    })
], default_1);
export default default_1;
